import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const initialState = {
    profile: {},
    orgDocs: {},
    orgKeyPerson: {},
};

// !########## SLICE #############
const profileSlice = createSlice({
    name: 'profileSlice',
    initialState,
    reducers: {
        setUserProfile: (state, action) => {
            let profile = action.payload;
            state.profile = profile;
            state.orgDocs = profile.documents;
            state.orgKeyPerson = profile.key_person;
            // => Update user Cookie
            cookies.set('user', profile);
        },
        setAuthUserProfile: (state, action) => {
            let profile = action.payload.user;
            state.profile = profile;
            state.orgDocs = profile.org_documents;
            state.orgKeyPerson = profile.key_person;
        },
        removeAuthUserProfile: (state, action) => {
            state.profile = {};
            state.orgDocs = {};
            state.orgKeyPerson = {};
        },
        resetProfileStates: (state) => {
            state.profile = {};
            state.orgDocs = {};
            state.orgKeyPerson = {};
        },
    },
});

export const {
    setUserProfile,
    setAuthUserProfile,
    removeAuthUserProfile,
    resetProfileStates,
} = profileSlice.actions;
export default profileSlice.reducer;
